<template>
  <div class="Status">
    <div v-for="data in datas" v-bind:key="data.sensor">
      
         
        <div class="field-label is-small">
            <label class="label">
            Czujnik nr {{data.sensor}}:
            <span v-if="data.valid" class="icon has-text-success">
               <fas icon="check-circle" />
               </span>
            <span v-else class="icon has-text-danger">
                <fas icon="ban" />
            </span>
            </label>
        </div> 
        
       
    </div>
    
    
   
  </div>
</template>

<script>



export default {
  name: 'Status',
  props: {
    data: Object,
    
  },
  data() {
    return {
      datas: [
          {sensor: 1, valid: 0, title: "Czujnik nr 1"},
          {sensor: 2, valid: 0, title: "Temperatura cwu - cyrkulacja"},
          {sensor: 3, valid: 0, title: "Temperatura co – zasilanie"},
          {sensor: 4, valid: 0, title: "Temperatura co – powrót"},
          {sensor: 5, valid: 0, title: "Temperatura kotłów"},
      ],
        
    }
  },
  mounted () {
    var objData = {
       id: this.data.id,
    
    }
    
    
    this.$store.dispatch('getValid', objData)
    .then(response => {
      //console.log("getLast2")
      
      this.buildForm(response)
    })
    .catch(error => {
        console.log(error)
        return error
    });
    
    
    
  },
  
  methods: {
    buildForm(_data){
      

      
          this.datas[0].valid = _data.t1;
          
        
          this.datas[1].valid = _data.t2;
          
       
          this.datas[2].valid = _data.t3;
          
       
          this.datas[3].valid = _data.t4;
          
       
          this.datas[4].valid = _data.t5;
          
        

      

    },
  }
}
</script>

<style scoped>
    .Status .label{
        font-weight: normal;

    }
  
</style>
